var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"conBox"},[_c('p',{staticClass:"first"},[_vm._v(" Email：wxyze@gmail.com ")]),_c('p',[_vm._v("Copyright © 2023 www.wxyze.com")]),_c('p',[_vm._v("All rights reserved.")])])])
}]

export { render, staticRenderFns }